export const Icons = {
  // Logo
  Logo: () => (
    <svg width="120" height="32" viewBox="0 0 120 32" fill="none">
      <rect x="4" y="4" width="24" height="24" rx="6" fill="#ff00ff"/>
      <rect x="8" y="8" width="16" height="16" rx="4" fill="#0a0a0f"/>
      <text x="36" y="22" fill="#e0e0ff" fontSize="18" fontWeight="700" fontFamily="Inter">okb</text>
    </svg>
  ),

  // Navigation icons
  Menu: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="3" y1="6" x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),

  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="18" y1="6" x2="6" y2="18"/>
      <line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),

  // Feature icons
  Security: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M24 4L6 12V22C6 32.5 14 41.67 24 44C34 41.67 42 32.5 42 22V12L24 4Z" stroke="#ff00ff" strokeWidth="2" fill="none"/>
      <path d="M18 24L22 28L30 20" stroke="#00ffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Shield: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M24 4C24 4 10 8 10 22C10 32 16 40 24 44C32 40 38 32 38 22C38 8 24 4 24 4Z" stroke="#ff00ff" strokeWidth="2" fill="rgba(255, 0, 255, 0.1)"/>
      <circle cx="24" cy="22" r="8" stroke="#00ffff" strokeWidth="2" fill="none"/>
      <path d="M20 22L23 25L28 19" stroke="#00ffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Lock: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="10" y="20" width="28" height="22" rx="4" stroke="#ff00ff" strokeWidth="2" fill="none"/>
      <path d="M16 20V14C16 9.58 19.58 6 24 6C28.42 6 32 9.58 32 14V20" stroke="#ff00ff" strokeWidth="2"/>
      <circle cx="24" cy="31" r="3" fill="#00ffff"/>
    </svg>
  ),

  Wallet: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <rect x="6" y="10" width="36" height="28" rx="6" stroke="#ff00ff" strokeWidth="2" fill="none"/>
      <path d="M6 18H42" stroke="#ff00ff" strokeWidth="2"/>
      <circle cx="34" cy="26" r="4" stroke="#00ffff" strokeWidth="2" fill="none"/>
    </svg>
  ),

  Chart: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M8 38L16 28L24 34L32 20L40 14" stroke="#ff00ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="16" cy="28" r="2" fill="#00ffff"/>
      <circle cx="24" cy="34" r="2" fill="#00ffff"/>
      <circle cx="32" cy="20" r="2" fill="#00ffff"/>
      <circle cx="40" cy="14" r="2" fill="#00ffff"/>
    </svg>
  ),

  Lightning: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M26 4L10 26H22L18 44L38 20H24L28 4H26Z" stroke="#ff00ff" strokeWidth="2" fill="rgba(255, 0, 255, 0.1)" strokeLinejoin="round"/>
    </svg>
  ),

  Globe: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="24" r="18" stroke="#ff00ff" strokeWidth="2" fill="none"/>
      <ellipse cx="24" cy="24" rx="8" ry="18" stroke="#00ffff" strokeWidth="2" fill="none"/>
      <line x1="6" y1="24" x2="42" y2="24" stroke="#00ffff" strokeWidth="2"/>
      <path d="M10 14H38" stroke="#00ffff" strokeWidth="2"/>
      <path d="M10 34H38" stroke="#00ffff" strokeWidth="2"/>
    </svg>
  ),

  Users: () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <circle cx="24" cy="14" r="8" stroke="#ff00ff" strokeWidth="2" fill="none"/>
      <path d="M8 42C8 32.06 15.16 24 24 24C32.84 24 40 32.06 40 42" stroke="#00ffff" strokeWidth="2"/>
    </svg>
  ),

  Check: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00ffff" strokeWidth="2">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),

  ChevronDown: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),

  ChevronRight: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),

  ArrowRight: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="4" y1="10" x2="16" y2="10"/>
      <polyline points="10 4 16 10 10 16"/>
    </svg>
  ),

  Download: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M10 3V13M10 13L6 9M10 13L14 9"/>
      <line x1="4" y1="17" x2="16" y2="17"/>
    </svg>
  ),

  ExternalLink: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 8V12C12 12.53 11.79 13.04 11.41 13.41C11.04 13.79 10.53 14 10 14H4C3.47 14 2.96 13.79 2.59 13.41C2.21 13.04 2 12.53 2 12V6C2 5.47 2.21 4.96 2.59 4.59C2.96 4.21 3.47 4 4 4H8"/>
      <path d="M10 2H14V6"/>
      <path d="M6 10L14 2"/>
    </svg>
  ),

  // Device icons
  Phone: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="6" y="2" width="12" height="20" rx="3" stroke="#ff00ff"/>
      <line x1="10" y1="18" x2="14" y2="18"/>
    </svg>
  ),

  Tablet: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="4" y="2" width="16" height="20" rx="3" stroke="#ff00ff"/>
      <line x1="10" y1="18" x2="14" y2="18"/>
    </svg>
  ),

  Desktop: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="12" rx="2" stroke="#ff00ff"/>
      <line x1="8" y1="21" x2="16" y2="21"/>
      <line x1="12" y1="15" x2="12" y2="21"/>
    </svg>
  ),

  // Social icons
  Twitter: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  ),

  Telegram: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>
  ),

  // Crypto icons
  Bitcoin: () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="14" fill="#F7931A"/>
      <path d="M21.7 14.5c.3-2-1.2-3-3.3-3.8l.7-2.8-1.7-.4-.7 2.8c-.4-.1-.9-.2-1.3-.3l.7-2.8-1.7-.4-.7 2.8c-.3-.1-.6-.2-1-.3l-.9-.2.5-2-1.6-.4-.5 2c-.9-.3-1.9-.5-2.9-.5.7 2.5 2.2 4.4 3.9 5.5-.9.4-2 .9-2.7 1.9-1.2 1.7-1 3.9-.1 5.5l.1.2c.3.4.6.8 1 1.1l-.5 2 1.7.4.7-2.8c.4.1.9.3 1.3.3l-.7 2.8 1.7.4.7-2.9c2.9.5 5.1-.3 6-2.3.7-1.5.3-2.8-.7-3.7 1-.2 1.9-.8 2.3-1.8z" fill="white"/>
    </svg>
  ),

  Ethereum: () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="14" fill="#627EEA"/>
      <path d="M16 6v8.87l7.5 3.35L16 6z" fill="white" fillOpacity=".6"/>
      <path d="M16 6L8.5 18.22l7.5-3.35V6z" fill="white"/>
      <path d="M16 21.96v5.74l7.5-10.4-7.5 4.66z" fill="white" fillOpacity=".6"/>
      <path d="M16 27.7v-5.74L8.5 17.3l7.5 10.4z" fill="white"/>
    </svg>
  ),

  TrendingUp: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00ff88" strokeWidth="2">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
      <polyline points="17 6 23 6 23 12"/>
    </svg>
  ),

  TrendingDown: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff4757" strokeWidth="2">
      <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
      <polyline points="17 18 23 18 23 12"/>
    </svg>
  ),
}

export default Icons
